const localizers = {
  'Alerts.noAlerts.txt': () => `Aucune alerte n’a été définie pour ce rapport.`,
  'BirdImage.image.txt': () => `Image`,
  'BirdText.editable.tooltip.txt': () => `Double-cliquez pour modifier le texte`,
  'ComboBox.clearFilter.txt': () => `Aucun filtre`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (Aucune donnée)`,
  'ContextMenu.selectAll.txt': () => `Sélectionner tout`,
  'ContextMenu.clearSelection.txt': () => `Annuler la sélection`,
  'ContextMenu.exportImage.txt': () => `Exporter sous forme d’image`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role} : Croissant`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role} : Décroissant`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role} : Ajout croissant`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role} : Ajout décroissant`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `Supprimer ${role} du tri`,
  'ContextMenu.removeSortLevel.txt': () => `Supprimer le niveau de tri`,
  'ContextMenu.sort.txt': () => `Tri`,
  'ContextMenu.selectShortestPath.txt': () => `Sélectionner le plus court chemin`,
  'ContextMenu.explain.txt': () => `Expliquer les données`,
  'ContextMenu.explainRole.txt': ({role}) => `Expliquer ${role}...`,
  'ContextMenu.manageColumns.txt': () => `Gérer les colonnes`,
  'ContextMenu.includeMissingValues.txt': () => `Inclure les valeurs manquantes`,
  'DrillableTooltip.drill.txt': () => `NAVIGATION`,
  'DrillableTooltip.tooltip.txt': () => `INFO-BULLE`,
  'DrillableTooltip.links.txt': () => `LIENS`,
  'DrillableTooltip.section.link.fmt': ({page}) => `Lien de page vers ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `Lien du rapport vers ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `Lien externe vers ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `Non disponible`,
  'Breadcrumb.all.fmt': ({label}) => `Tout ${label}`,
  'BrowserCheck.title.txt': () => `Vérification WebGL`,
  'BrowserCheck.msg.txt': () => `WebGL est soit désactivé, soit non pris en charge par votre navigateur.   \nCliquez sur OK pour afficher le rapport dans le visualiseur classique.`,
  'EmailUtil.subject.multiple.txt': () => `Rapports à vérifier`,
  'EmailUtil.tooLongEmail.txt': () => `La limite de longueur d’e-mail a été dépassée. Réduisez le nombre de rapports à envoyer par e-mail.`,
  'HiddenSectionDialog.close.txt': () => `Fermer`,
  'HiddenSectionDialog.export.txt': () => `Exporter au format PDF`,
  'InfoPanel.information.txt': () => `Informations`,
  'InfoPanel.comments.txt': () => `Commentaires`,
  'InfoPanel.alerts.txt': () => `Alertes`,
  'IncomingFilters.promptbars.txt': () => `Barres d’invites`,
  'Information.title.txt': () => `Titre`,
  'Information.name.txt': () => `Nom :`,
  'Information.description.txt': () => `Description :`,
  'Information.displayRules.txt': () => `Règles d’affichage :`,
  'Information.graphLevel.txt': () => `Niveau graphique`,
  'Information.reportLevel.txt': () => `Niveau rapport`,
  'Information.legend.txt': () => `Légende`,
  'Information.incomingFilters.txt': () => `Filtres entrants :`,
  'Information.noIncomingFilters.txt': () => `Pas de filtres entrants`,
  'Information.dataSourceFilters.txt': () => `Filtres de source de données :`,
  'Information.interactiveFilters.txt': () => `Filtres interactifs :`,
  'MobileContainer.mobileBIMessage.txt': () => `Accéder à des rapports SAS sur votre appareil mobile.`,
  'ObjectTypes.report.txt': () => `Rapport`,
  'ObjectTypes.Report.BI.txt': () => `Rapport SAS (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Rapport d’application stockée`,
  'ObjectTypes.StoredProcess.txt': () => `Application stockée`,
  'MissingValues.label.txt': () => `(valeurs manquantes)`,
  'PromptContainer.apply.txt': () => `OK`,
  'PromptContainer.cancel.txt': () => `Annuler`,
  'PromptContainer.close.txt': () => `Fermer`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `La valeur doit être un nombre entre ${min} et ${max} inclus.`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Spécifiez une valeur numérique valide.`,
  'TextFieldTypeAhead.validation.string.txt': () => `La valeur n’est pas valide pour les données attribuées.`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Saisir : ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Saisir : ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `Saisir ${placeholderLabel}...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label} : ${min}–${max}`,
  'Slider.missingValues.txt': () => `Valeurs manquantes`,
  'Slider.missingValues.tooltip.fmt': ({rangeLabel}) => `${rangeLabel} inclut les valeurs manquantes`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel} : ${categoryValue}, ${measureLabel} : ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel} : ${categoryValue}`,
  'ReportContainer.back.txt': () => `Retour`,
  'ReportContainer.reportCorrupted.txt': () => `RAPPORT ENDOMMAGÉ`,
  'ReportContainer.themeLoadFailed.txt': () => `Le thème du rapport n’a pas pu être chargé.`,
  'ReportContainer.restoreButton.tip.txt': () => `Restaurer un rapport`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Rapport restauré`,
  'ReportContainer.renderError.txt': () => `Une erreur s’est produite. Impossible d’afficher le rapport.`,
  'ReportContainer.component.renderError.txt': () => `Une erreur s’est produite. Impossible de restituer le composant.`,
  'ReportContentPage.open.txt': () => `Ouvrir...`,
  'ReportContentPage.refreshReport.txt': () => `Actualiser le rapport`,
  'ReportContentPage.editReport.txt': () => `Modifier le rapport`,
  'ReportContentPage.print.txt': () => `Imprimer...`,
  'ReportContentPage.email.txt': () => `E-mail...`,
  'ReportContentPage.export.txt': () => `Exporter vers Excel...`,
  'ReportContentPage.reportProperties.txt': () => `Propriétés du rapport`,
  'ReportContentPage.shareReport.txt': () => `Partager le rapport`,
  'ReportContentPage.enableOverlays.txt': () => `Activer les superpositions d’objets`,
  'ReportContentPage.disableOverlays.txt': () => `Désactiver les superpositions d’objets`,
  'ReportContentPage.link.txt': () => `Lien...`,
  'ReportContentPage.settings.txt': () => `Paramètres...`,
  'ReportContentPage.editPlayback.txt': () => `Modifier la lecture`,
  'ReportContentPage.playReport.txt': () => `Lire le rapport`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Afficher les filtres avec invite`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `Masquer les filtres avec invite`,
  'ReportContentPage.reportFilters.txt': () => `Niveau rapport`,
  'ReportContentPage.pageFilters.txt': () => `Niveau page`,
  'ReportContentPage.refreshRequired.txt': () => `L’actualisation du rapport est obligatoire`,
  'ReportContentPage.infoButton.tip.txt': () => `Volet d’informations`,
  'ReportContentPage.backButton.tip.txt': () => `Afficher tous les rapports`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `Plus d’options`,
  'ReportContentPage.itemGroupName.txt': () => `Rapports`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Agrandir le rapport`,
  'ReportContentPage.closeButton.txt': () => `Fermer le rapport`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Rapport agrandi`,
  'ReportContentPage.resetReportState.txt': () => `Restaurer l’état du rapport par défaut`,
  'ReportContentPage.summary.txt': () => `Afficher la synthèse`,
  'ReportManagerPage.objectMenu.open.txt': () => `Ouvrir`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Modifier`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Synthèse`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Propriétés`,
  'ReportManagerPage.objectMenu.email.txt': () => `E-mail...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Imprimer`,
  'ReportManagerPage.browseReportsButton.txt': () => `Parcourir les rapports`,
  'ReportManagerPage.newReportButton.txt': () => `Nouveau rapport`,
  'ReportManagerPage.emptyView.message.txt': () => `Aucun rapport trouvé.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Parcourir les rapports`,
  'ReportManagerPage.tableView.name.txt': () => `Nom`,
  'ReportManagerPage.tableView.author.txt': () => `Auteur`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Dernière modification`,
  'ReportManagerPage.openButton.tip.txt': () => `Ouvrir un rapport`,
  'ReportManagerPage.emailButton.tip.txt': () => `Envoyer le rapport par e-mail`,
  'ReportManagerPage.printButton.tip.txt': () => `Imprimer le rapport au format PDF`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Propriétés du rapport`,
  'ReportObject.multipleReferences.error.txt': () => `Les objets du rapport ne peuvent pas être utilisés dans plusieurs contextes.`,
  'ReportObject.notFound.error.txt': () => `Le nom de l’objet est introuvable dans le rapport spécifié.`,
  'ReportObject.invalidPage.error.txt': () => `La page spécifiée est non valide.`,
  'ReportPropertiesDialog.open.txt': () => `Ouvrir`,
  'ReportPropertiesDialog.close.txt': () => `Fermer`,
  'ReportPropertiesDialog.name.txt': () => `Nom :`,
  'ReportPropertiesDialog.description.txt': () => `Description :`,
  'ReportPropertiesDialog.keywords.txt': () => `Mots-clés :`,
  'ReportPropertiesDialog.type.txt': () => `Type :`,
  'ReportPropertiesDialog.location.txt': () => `Emplacement :`,
  'ReportPropertiesDialog.createdBy.txt': () => `Créé par :`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Créé le :`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Modifié par :`,
  'ReportPropertiesDialog.dateModified.txt': () => `Modifié le :`,
  'ReportSections.newPageButton.txt': () => `Nouvelle page`,
  'ReportSections.closeTab.tooltip.txt': () => `Supprimer la page`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `Menu ${label}`,
  'ReportSummaryDialog.title.txt': () => `Synthèse`,
  'ReportSummaryDialog.open.txt': () => `Ouvrir`,
  'ReportSummaryDialog.cancel.txt': () => `Annuler`,
  'ReportSummaryDialog.close.txt': () => `Fermer`,
  'ReportSummaryDialog.noSummary.txt': () => `Aucune synthèse disponible.`,
  'ReportTileBody.modifiedBy.txt': () => `Modifié par :`,
  'ReportTileBody.lastModified.txt': () => `Dernière modification :`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS Report Viewer`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Actualisation du rapport`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Actualiser automatiquement le rapport`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Rechercher les mises à jour après ce nombre de minutes :`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Notifications d’alertes`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Sélectionnez les notifications d’alertes par défaut :`,
  'VAViewerSettingsProvider.alert.email.txt': () => `Envoyer des e-mails`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `Envoyer des messages texte SMS`,
  'VAViewerSettingsProvider.alert.system.txt': () => `Paramètre administrateur par défaut`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Thèmes`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Remplacer le thème du rapport par le thème SAS High Contrast`,
  'ViewerBusyDialog.openReport.txt': () => `Ouverture du rapport...`,
  'ViewerBusyDialog.prepareExport.txt': () => `Préparation de l’exportation...`,
  'ViewerBusyDialog.preparePrint.txt': () => `Préparation de l’impression...`,
  'PDFGeneration.printingReport.txt': () => `Génération d’un rapport PDF. Il sera téléchargé dès qu’il sera prêt.`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `${fileName} le ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Sélectionner une action`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `Vous avez atteint le niveau le plus bas de la hiérarchie.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `Vous avez atteint le niveau le plus bas de toutes les hiérarchies.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `Zoom avant sur ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `Instantané de ${a0} ${a1} à ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Enregistrer l’image`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Imprimer l’objet...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Partager l’objet...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `Plus`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `Menu Objet de ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `Afficher avec SAS® Graphics Accelerator`,
  'ZoomControl.button.tip.txt': () => `Zoom`,
  'ZoomControl.button.zoomin.txt': () => `Zoom avant`,
  'ZoomControl.button.zoomout.txt': () => `Zoom arrière`,
  'ZoomControl.button.display.txt': () => `Contrôles du zoom`,
  'ZoomControl.button.reset.txt': () => `Réinitialiser le zoom`,
  'ExpandControl.button.expand.txt': () => `Agrandir la vue`,
  'ExpandControl.button.restore.txt': () => `Restaurer la vue`,
  'ExpandControl.button.expand.tip.txt': () => `Agrandir`,
  'ExpandControl.button.restore.tip.txt': () => `Restaurer`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Les liens des pages ne peuvent pas être exécutés tant que cet objet est agrandi.`,
  'DragModeControl.button.pan.tip.txt': () => `Panoramique`,
  'DragModeControl.button.circular.tip.txt': () => `Sélection circulaire`,
  'DragModeControl.button.freeform.tip.txt': () => `Sélection forme libre`,
  'DragModeControl.button.rectangular.tip.txt': () => `Sélection rectangulaire`,
  'DragModeControl.button.zoom.tip.txt': () => `Zoom sur le rectangle`,
  'ReportXMLDialog.title.txt': () => `XML du rapport`,
  'ReportXMLDialog.closeButton.txt': () => `Fermer`,
  'ReportXMLDialog.copyButton.txt': () => `Copier dans le Presse-papiers`,
  'ReportXMLDialog.error.txt': () => `Erreur lors du chargement du XML du rapport`,
  'ErrorDialog.error.txt': () => `Une erreur s’est produite. Contactez votre administrateur système.`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - Visualiseur de rapport`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Ouvrir un rapport`,
  'OpenReportDialog.reports.txt': () => `Rapports :`,
  'OpenReportDialog.cancel.txt': () => `Annuler`,
  'OpenReportDialog.ok.txt': () => `OK`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `${count} objets mis à jour`,
  'AriaLive.oneObjectUpdated.txt': () => `1 objet mis à jour`,
  'AriaLive.reportOpened.txt': () => `Rapport ouvert`,
  'AriaLive.reportClosed.txt': () => `Rapport fermé`,
  'ExportData.generating.txt': () => `Génération de l’exportation. Elle sera téléchargée dès qu’elle sera prête.`,
  'ExportData.warning.txt': () => `Erreur lors de la génération des données`,
  'ExportData.nodata.txt': () => `Pas de données à exporter`,
  'ExportData.exportData.txt': () => `Exporter les données...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Enregistrer`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `Annuler`,
  'PlaybackAnimationDialog.playButton.txt': () => `Lire le rapport`,
  'PlaybackAnimationDialog.title.txt': () => `Modifier la lecture`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Unité de transition :`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Page`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Objet`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Secondes par unité :`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Afficher les objets agrandis :`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Afficher uniquement la zone de dessin :`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Afficher l’horloge :`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Afficher les contrôles de navigation en cliquant ou en touchant :`,
  'PlaybackNavigationControls.previousPage.txt': () => `Page précédente`,
  'PlaybackNavigationControls.nextPage.txt': () => `Page suivante`,
  'PlaybackNavigationControls.previousObject.txt': () => `Objet précédent`,
  'PlaybackNavigationControls.nextObject.txt': () => `Objet suivant`,
  'TransportConnection.generateReportTimeout.txt': () => `Le chargement du rapport prend beaucoup de temps. Voulez-vous continuer ?`,
  'TransportConnection.openReport.txt': () => `Ouvrir un rapport`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `Le rapport spécifié à l’emplacement suivant n’existe pas : ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `Développer ${label}`,
  'Hierarchy.collapse.fmt': ({label}) => `Réduire ${label}`,
  'GraphElementDecorator.overview.txt': () => `Présentation`,
  'GraphElementDecorator.layers.txt': () => `Masquer ou afficher les couches`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Masquer la présentation`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Afficher la présentation`,
  'TitleInfoButton.tooltip.txt': () => `Informations`,
  'SectionSelectionBar.noSelections.txt': () => `Aucune sélection`,
  'SectionSelectionBar.title.txt': () => `Filtres :`,
  'CheckboxList.selectAll.txt': () => `Sélectionner tout`,
  'CheckboxList.clearSelection.txt': () => `Annuler la sélection`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Annuler la sélection (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Explication de ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `Préparation de l’explication...`,
  'ExplanationInfoDialog.cancel.txt': () => `Annuler`,
  'ExplanationInfoDialog.close.txt': () => `Fermer`,
  'PromptHeader.emptyReport.txt': () => `Faites glisser un élément de données ou un contrôle ici pour créer une invite de rapport.`,
  'PromptHeader.emptyPage.txt': () => `Faites glisser un élément de données ou un contrôle ici pour créer une invite de page.`,
  'PromptHeader.collapsePageControlArea.txt': () => `Réduire la zone de contrôle de la page`,
  'PromptHeader.expandPageControlArea.txt': () => `Développer la zone de contrôle de la page`,
  'PromptHeader.collapseReportControlArea.txt': () => `Réduire la zone de contrôle du rapport`,
  'PromptHeader.expandReportControlArea.txt': () => `Développer la zone de contrôle du rapport`,
  'PromptHeader.collapseControlArea.txt': () => `Réduire la zone de contrôle`,
  'PromptHeader.expandControlArea.txt': () => `Développer la zone de contrôle`,
  'PromptHeader.reportControlArea.txt': () => `Zone de contrôle du rapport`,
  'PromptHeader.allControlAreas.txt': () => `Toutes les zones de contrôle`,
  'PromptHeader.pageControlArea.txt': () => `Zone de contrôle de la page`,
  'ZeroState.editMode.txt': () => `Faites glisser un template, des éléments de données ou des objets ici.`,
  'ZeroState.viewMode.txt': () => `Aucun contenu à afficher.`,
  'ObjectStatus.assignData.txt': () => `Affecter des données`,
  'ObjectStatus.selectImage.txt': () => `Sélectionner une image`,
  'ObjectStatus.selectJob.txt': () => `Sélectionner le job`,
  'ObjectStatus.cancelLoading.txt': () => `Annuler le chargement`,
  'ObjectStatus.loadingCanceled.txt': () => `Chargement annulé`,
  'ObjectStatus.resumeLoading.txt': () => `Reprendre le chargement`,
  'ObjectStatus.refresh.txt': () => `Actualiser`,
  'ObjectStatus.setJobParameters.txt': () => `Définir les valeurs des paramètres`,
  'ObjectSearch.title.txt': () => `Recherche géographique`,
  'ObjectSearch.pin.txt': () => `Épingle`,
  'ObjectSearch.unpin.txt': () => `Détacher`,
  'MainSearchPanel.searchHints.txt': () => `Conseils pour la recherche`,
  'MainSearchPanel.searchResults.txt': () => `Résultats de la recherche`,
  'MainSearchPanel.features.txt': () => `Fonctionnalités`,
  'MainSearchPanel.pin.txt': () => `Nouvelle épingle`,
  'MainSearchPanel.pin.tooltip.txt': () => `Nouvelle épingle`,
  'MainSearchPanel.route.txt': () => `Nouvel itinéraire`,
  'MainSearchPanel.route.tooltip.txt': () => `Nouvel itinéraire`,
  'MainSearchPanel.geographicArea.txt': () => `Nouvelle zone géographique`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `Nouvelle zone géographique`,
  'MainSearchPanel.newMyLocationPin.txt': () => `Mon épingle d’emplacement`,
  'MainSearchPanel.myLocationPin.txt': () => `Mon emplacement`,
  'MainSearchPanel.show.txt': () => `Afficher`,
  'MainSearchPanel.show.all.txt': () => `Afficher tout`,
  'MainSearchPanel.hide.txt': () => `Masquer`,
  'MainSearchPanel.hide.all.txt': () => `Masquer tout`,
  'MainSearchPanel.delete.txt': () => `Supprimer`,
  'MainSearchPanel.delete.all.txt': () => `Supprimer tout`,
  'MainSearchPanel.convert.txt': () => `Convertir les résultats de recherche en épingles`,
  'MainSearchPanel.convert.all.txt': () => `Convertir tous les résultats de recherche en épingles`,
  'MainSearchPanel.showPinLabels.txt': () => `Afficher les libellés d’épingle`,
  'MainSearchPanel.close.label.txt': () => `Recherche géographique`,
  'MainSearchPanel.navigate.tooltip.txt': () => `Afficher les détails`,
  'MainSearchPanel.demographics.tooltip.txt': () => `Démographie`,
  'PanelHeader.back.tooltip.txt': () => `Retour`,
  'GeographicAreaPanel.title.txt': () => `Zone géographique`,
  'GeographicAreaPanel.draw.txt': () => `Zone de dessin`,
  'GeographicAreaPanel.update.txt': () => `Zone de mise à jour`,
  'GeographicAreaPanel.label.txt': () => `Libellé :`,
  'GeographicAreaPanel.location.txt': () => `Emplacement :`,
  'GeographicAreaPanel.distance.miles.txt': () => `Distance (mile) :`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `Distance (km) :`,
  'GeographicAreaPanel.distance.add.txt': () => `Ajouter une distance`,
  'GeographicAreaPanel.time.add.txt': () => `Ajouter une heure`,
  'GeographicAreaPanel.distance.delete.txt': () => `Supprimer la distance`,
  'GeographicAreaPanel.time.minutes.txt': () => `Temps (min) :`,
  'GeographicAreaPanel.duration.txt': () => `Durée :`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Miles`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Kilomètres`,
  'GeographicAreaPanel.menu.clear.txt': () => `Effacer la zone géographique`,
  'GeographicAreaPanel.menu.link.txt': () => `Associer l’adresse aux éléments de données et aux épingles par défaut`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Dissocier l’adresse de la zone géographique`,
  'GeographicAreaPanel.menu.delete.txt': () => `Supprimer la zone géographique`,
  'GeographicAreaPanel.demographics.txt': () => `Démographie`,
  'GeographicAreaPanel.demographics.set.txt': () => `Afficher la démographie`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Développer la vue`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Modifier les données démographiques`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Supprimer les données démographiques`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Les données démographiques doivent être rechargées`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Recharger les données démographiques`,
  'GeographicAreaPanel.invalid.location.txt': () => `La zone géographique n’a pas d’emplacement valide et ne peut pas être créée.`,
  'TravelTypeField.dateselector.tooltip.txt': () => `Sélectionner un jour et une heure`,
  'TravelTypeField.cancel.txt': () => `Annuler`,
  'TravelTypeField.ok.txt': () => `OK`,
  'TravelTypeField.button.tooltip.txt': () => `Sélectionner un jour et une heure`,
  'TravelTypeField.day.txt': () => `Jour :`,
  'TravelTypeField.time.txt': () => `Heure :`,
  'TravelTypeField.distanceTypes.direct.txt': () => `Direct`,
  'TravelTypeField.distanceTypes.distance.txt': () => `Distance`,
  'TravelTypeField.travelType.txt': () => `Type de déplacement :`,
  'TravelTypeField.traffic.txt': () => `Inclure le trafic :`,
  'TravelTypeField.traffic.offset.txt': () => `Décalage heure de trafic :`,
  'TravelTypeField.traffic.daytime.txt': () => `Jour et heure de trafic :`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `Unité de distance`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `Distance de parcours`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `Temps de parcours`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `Distance du parcours en camion`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `Temps de parcours en camion`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `Distance du parcours à pied`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `Temps de parcours à pied`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `Non`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `Trafic actuel`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `Trafic type`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} h`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `Mettre à jour le trafic pour cette fonctionnalité`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `Mettre à jour le trafic pour toutes les fonctionnalités`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `Mettre à jour les données de trafic`,
  'RoutePanel.title.txt': () => `Itinéraire`,
  'RoutePanel.draw.txt': () => `Tracer l’itinéraire`,
  'RoutePanel.update.txt': () => `Mettre à jour l’itinéraire`,
  'RoutePanel.label.txt': () => `Libellé :`,
  'RoutePanel.locations.txt': () => `Emplacements`,
  'RoutePanel.menu.clear.txt': () => `Effacer l’itinéraire`,
  'RoutePanel.menu.reverse.txt': () => `Itinéraire inversé`,
  'RoutePanel.menu.add.waypoint.txt': () => `Ajouter l’emplacement de l’itinéraire`,
  'RoutePanel.menu.delete.waypoint.txt': () => `Supprimer l’emplacement de l’itinéraire`,
  'RoutePanel.menu.unlink.txt': () => `Annuler le lien de l’emplacement de l’itinéraire`,
  'RoutePanel.menu.arrows.txt': () => `Flèches d’itinéraire`,
  'RoutePanel.menu.arrows.hide.txt': () => `Masquer les flèches d’itinéraire`,
  'RoutePanel.menu.arrows.show.txt': () => `Afficher les flèches d’itinéraire`,
  'RoutePanel.menu.arrows.oneway.txt': () => `Unidirectionnel`,
  'RoutePanel.menu.arrows.twoway.txt': () => `Bidirectionnel`,
  'RoutePanel.menu.delete.txt': () => `Supprimer l’itinéraire`,
  'RoutePanel.route.width.txt': () => `Largeur de l’itinéraire`,
  'RoutePanel.distance.txt': () => `Distance :`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} mi`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} km`,
  'RoutePanel.location.add.txt': () => `Ajouter un emplacement`,
  'RoutePanel.location.delete.txt': () => `Supprimer l’emplacement`,
  'RoutePanel.duration.txt': () => `Heure :`,
  'RoutePanel.invalid.location.txt': () => `La route n’a pas d’emplacements valides et ne peut pas être créée.`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `Emplacement ${index}, ${location}, entrée`,
  'PinPanel.pinTitle.txt': () => `Épingle`,
  'PinPanel.addDescription.txt': () => `Ajouter une description`,
  'PinPanel.deleteDescription.txt': () => `Supprimer la description`,
  'PinPanel.newPin.txt': () => `Nouvelle épingle à cet emplacement`,
  'PinPanel.deletePin.txt': () => `Supprimer l’épingle`,
  'PinPanel.linkPins.txt': () => `Lier les épingles aux éléments de données par défaut`,
  'PinPanel.unlinkAllItems.txt': () => `Supprimer les liens pour tous les éléments`,
  'PinPanel.unlinkItems.txt': () => `Supprimer les liens pour les éléments`,
  'PinPanel.label.txt': () => `Libellé :`,
  'PinPanel.location.txt': () => `Emplacement :`,
  'PinPanel.description.txt': () => `Description :`,
  'PinPanel.linked.txt': () => `LIÉS`,
  'PinPanel.searchClickPlaceholder.txt': () => `Rechercher ou sélectionner sur la carte`,
  'PinPanel.searchPlaceholder.txt': () => `Recherche`,
  'PinPanel.addRoute.txt': () => `Ajouter un itinéraire`,
  'PinPanel.addRoute.tooltip.txt': () => `Ajouter un itinéraire`,
  'PinPanel.addArea.txt': () => `Ajouter une zone géographique`,
  'PinPanel.addArea.tooltip.txt': () => `Ajouter une zone géographique`,
  'PinPanel.addArea.title.txt': () => `Ajouter une zone géographique`,
  'PinPanel.myLocationTitle.txt': () => `Mon épingle d’emplacement`,
  'PinPanel.deleteMyLocationPin.txt': () => `Supprimer Mon épingle d’emplacement`,
  'PinPanel.enableAutoUpdate.txt': () => `Activer la mise à jour automatique de Mon emplacement`,
  'PinPanel.disableAutoUpdate.txt': () => `Désactiver la mise à jour automatique de Mon emplacement`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Modifier l’intervalle d’actualisation automatique de Mon emplacement...`,
  'PinPanel.linkToPin.txt': () => `Lien vers l’épingle`,
  'PinPanel.useCurrentLocation.txt': () => `Utiliser l’emplacement actuel de l’épingle`,
  'PinPanel.notDrawn.txt': () => `Non tracé`,
  'PinPanel.undetermined.txt': () => `Non déterminé`,
  'PinPanel.findMyLocation.txt': () => `Rechercher ma position`,
  'PinPanel.cannotDetermineLocation.txt': () => `L’application ne peut pas déterminer votre emplacement actuel. Si vous souhaitez partager votre position, consultez l’aide de votre navigateur ou de votre appareil.`,
  'PinPanel.autoRefreshInterval.txt': () => `Intervalle d’actualisation automatique de Mon emplacement`,
  'PinPanel.interval.hours.txt': () => `Heures :`,
  'PinPanel.interval.minutes.txt': () => `Minutes :`,
  'PinPanel.interval.seconds.txt': () => `Secondes :`,
  'PinPanel.invalid.location.txt': () => `L’épingle n’a pas d’emplacement valide et ne peut pas être créée.`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} mi`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}; ${value2} mi`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} mi`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} km`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}; ${value2} km`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} km`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} min`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}; ${value2} min`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} min`,
  'PinPanel.clearLocation.tooltip.txt': () => `Effacer le texte de l’emplacement`,
  'DiscardChangesDialog.title.area.txt': () => `Zone géographique`,
  'DiscardChangesDialog.title.route.txt': () => `Itinéraire`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `Vous avez modifié la zone géographique sans l’avoir redessinée.\n\nVoulez-vous ignorer les modifications apportées à ${label} ?`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `Vous avez modifié l’itinéraire géographique sans l’avoir redessiné.\n\nVoulez-vous ignorer les modifications apportées à ${label} ?`,
  'DiscardChangesDialog.discard.txt': () => `Ignorer`,
  'DiscardChangesDialog.cancel.txt': () => `Annuler`,
  'FeatureErrorDialog.title.area.txt': () => `Tracer la zone géographique`,
  'FeatureErrorDialog.title.route.txt': () => `Tracer l’itinéraire`,
  'FeatureErrorDialog.text.area.txt': () => `Impossible de tracer la zone géographique.\n\nAstuce : Si l’emplacement de votre zone ne contient pas d’infrastructure de déplacement telle que des routes, il peut être impossible de calculer une zone géographique. Utilisez plutôt un type de déplacement basé sur la distance ou déplacez la zone vers un emplacement doté d’une infrastructure de déplacement.`,
  'FeatureErrorDialog.text.route.txt': () => `Impossible de tracer l’itinéraire...\n\nAstuce : Si l’emplacement de votre itinéraire ne contient pas d’infrastructure de déplacement telle que des routes, il peut être impossible de calculer une itinéraire. Utilisez plutôt un type de déplacement basé sur la distance ou déplacez l’itinéraire vers un emplacement doté d’une infrastructure de déplacement.`,
  'FeatureErrorDialog.close.txt': () => `Fermer`,
  'DemographicsSelectorDialog.title.txt': () => `Afficher la démographie`,
  'DemographicsSelectorDialog.cancel.txt': () => `Annuler`,
  'DemographicsSelectorDialog.ok.txt': () => `OK`,
  'DemographicsSelectorDialog.country.txt': () => `Pays/Région`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `De base`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Avancé`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Récent`,
  'DemographicsSelectorDialog.categories.txt': () => `Catégories`,
  'DemographicsSelectorDialog.category.income.txt': () => `Revenu`,
  'DemographicsSelectorDialog.category.age.txt': () => `Âge`,
  'DemographicsSelectorDialog.category.households.txt': () => `Foyers`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Logement`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Situation de famille`,
  'DemographicsSelectorDialog.category.population.txt': () => `Population`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `Groupe d’utilisateurs`,
  'DemographicsSelectorDialog.category.health.txt': () => `Santé`,
  'DemographicsSelectorDialog.category.education.txt': () => `Éducation`,
  'DemographicsSelectorDialog.category.business.txt': () => `Métier`,
  'DemographicsSelectorDialog.category.race.txt': () => `Course`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Dépenses`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Comportements`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `Jobs`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Pauvreté`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Tapisserie`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `À risque`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Faits essentiels`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Offre et demande`,
  'DemographicsSelectorDialog.category.policy.txt': () => `Directive`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Paysage`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Crime`,
  'ManageColumns.title.txt': () => `Gérer les colonnes`,
  'ManageColumns.ok.txt': () => `OK`,
  'ManageColumns.cancel.txt': () => `Annuler`,
  'ManageColumns.hiddenColumns.txt': () => `Colonnes masquées`,
  'ManageColumns.displayedColumns.txt': () => `Colonnes affichées`,
  'SearchResultPanel.title.txt': () => `Résultat de la recherche`,
  'SearchResultPanel.menu.delete.txt': () => `Supprimer le résultat de la recherche`,
  'SearchResultPanel.convert.txt': () => `Convertir en épingle`,
  'SearchResultPanel.convert.tooltip.txt': () => `Convertir en épingle`,
  'DemographicsResultsDialog.title.txt': () => `Démographie`,
  'DemographicsResultsDialog.cancel.txt': () => `Annuler`,
  'DemographicsResultsDialog.close.txt': () => `Fermer`,
  'DemographicsResultsDialog.edit.txt': () => `Modifier`,
  'DemographicsResultsDialog.layout.page.txt': () => `Vue Carrousel`,
  'DemographicsResultsDialog.layout.list.txt': () => `Vue Colonne unique`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Vue en mosaïque`,
  'DemographicsResultsDialog.noData.txt': () => `Aucune donnée ne correspond à la zone géographique actuelle.`,
  'PinsAtSameLocationPanel.title.txt': () => `Épingles au même emplacement`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `RÉSULTATS DE LA RECHERCHE`,
  'PinsAtSameLocationPanel.pins.txt': () => `ÉPINGLES`,
  'PinsAtSameLocationPanel.showAll.txt': () => `Afficher tout`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `Masquer tout`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `Supprimer tout`,
  'PinsAtSameLocationPanel.show.txt': () => `Afficher`,
  'PinsAtSameLocationPanel.hide.txt': () => `Masquer`,
  'PinsAtSameLocationPanel.delete.txt': () => `Supprimer`,
  'LocationPopover.pin.title.txt': () => `Emplacement de l’épingle`,
  'LocationPopover.area.title.txt': () => `Emplacement de la zone géographique`,
  'LocationPopover.route.title.txt': ({label}) => `Emplacement de l’itinéraire ${label}`,
  'LocationPopover.name.txt': () => `Nom`,
  'LocationPopover.location.txt': () => `Emplacement :`,
  'LocationPopover.ok.txt': () => `Définir l’emplacement`,
  'LocationPopover.cancel.txt': () => `Quitter le mode de sélection`,
  'LocationPopover.hint.txt': () => `Cliquez à nouveau sur la carte pour identifier un autre emplacement.`,
  'TreeDualSelector.source.default.txt': () => `Éléments disponibles`,
  'TreeDualSelector.target.default.txt': () => `Éléments sélectionnés`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} sur ${totalLength}) :`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}) :`,
  'TreeDualSelector.emptymessage.txt': () => `Aucun élément`,
  'TreeDualSelector.filter.placeholder.txt': () => `Filtrer`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `Élément personnalisé`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} éléments ajoutés`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} éléments supprimés`,
  'TreeDualSelector.afterAction.addAll.txt': () => `Tous les éléments sont ajoutés`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `Tous les éléments sont supprimés`,
  'TreeDualSelector.afterAction.up.txt': () => `Monté`,
  'TreeDualSelector.afterAction.down.txt': () => `Descendu`,
  'TreeDualSelector.afterAction.top.txt': () => `Déplacé vers le haut`,
  'TreeDualSelector.afterAction.bottom.txt': () => `Déplacé vers le bas`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `Action d’ajout annulée`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `Action de suppression annulée`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `élément personnalisé ajouté`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `${customItemSelected} élément personnalisé sélectionné`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `${itemSelected} ${itemDescription} sélectionné`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} sélectionné`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `Monter d’une ligne dans ${targetListLabel}`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `Descendre d’une ligne dans ${targetListLabel}`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `Déplacer vers le haut de ${targetListLabel}`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `Déplacer vers le bas de ${targetListLabel}`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `Ajouter l’élément à ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `Tout ajouter dans ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `Supprimer l’élément de ${targetListLabel}`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `Supprimer tout dans ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `Annuler l’ajout pour ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `Annuler la suppression pour ${targetListLabel}`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `Filtrer ${listLabel}`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `Supprimer`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `Si vous continuez, tous les éléments personnalisés que vous avez sélectionnés pour la suppression seront définitivement supprimés.\n\n Voulez-vous continuer ?`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `Supprimer tous les éléments`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `Les éléments personnalisés de cette liste seront définitivement supprimés si vous continuez.\n\n Voulez-vous continuer ?`,
  'LinkNavigator.backButton.label': () => `Retour`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel} : ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `Filtres entrants`,
  'LinkNavigator.reportLevel.label': () => `Niveau rapport`,
  'LinkNavigator.sectionLevel.label': () => `Niveau page`,
  'ReportSectionZeroState.heading.label': () => `Créer un rapport`,
  'ReportSectionZeroState.description.label': () => `Faites glisser des objets ou des éléments de données sur la page ou sélectionnez une option ci-dessous.`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `Faites glisser des objets ou des éléments de données sur la page, ou démarrez à l’aide d’un template de page.`,
  'ReportSectionZeroState.autoChartButton.label': () => `Générer l’objet`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `Sélectionner un template`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `Explorer les suggestions`,
  'PromptContainerTooltip.noSelections.txt': () => `Aucune sélection`,
  'PromptContainerTooltip.selectedValues.txt': () => `Valeurs sélectionnées`,
}
export default localizers;
